<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- B100系共通部品_Steps -->
    <app-b100-steps></app-b100-steps>

    <div class="information-margin"></div>

    <!-- 自治体会員登録・更新画面(入力)(B101) -->
    <div *ngIf="!confirmationFlag">
      <!-- タイトル -->
      <div class="title">
        <h1>会員プロフィール編集</h1>
      </div>

      <!-- 入力フォーム -->
      <form [formGroup]="b101InputForm">
        <!-- 入力情報 -->
        <div class="input-form-information">
          <!-- 入力備考 -->
          <div class="input-form-note">
            <label>
              貴団体のSDGsに関する活動内容についてご記載ください。<br />
              ご記載頂いた内容は、「非公開」となっている箇所を除き、会員間で共有されますので、公開可能な情報のみご記載ください。<br />
              以下の項目に必要事項をご記載後、「確認画面へ進む」ボタンをクリックしてください。一時保存はできません。<br />
            </label>
            <label class="warning-note">
              ※【必須】の項目は入力必須項目です。必ずご記載ください。<br />
            </label>
            <!-- 公開 -->
            <p-tag value="公開" styleClass="public-tag"></p-tag>
            …本プラットフォームＨＰに掲載する情報です。<br />
            <!-- 非公開 -->
            <p-tag value="非公開" styleClass="private-tag"></p-tag>
            …本プラットフォームＨＰに掲載しない情報です。
          </div>

          <!-- 入力内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 会員種別 -->
              <tr>
                <td class="item-input-name">会員種別</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <label *ngIf="9 != b101InputForm.value.class_id">
                    {{ getDicName(1, b101InputForm.value.class_id) }}
                  </label>
                  <label *ngIf="9 == b101InputForm.value.class_id">
                    事務局
                  </label>
                </td>
              </tr>
              <!-- 団体名称 -->
              <tr>
                <td class="item-input-name">団体名称</td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  {{ b101InputForm.value.organization_name }}
                  <br />
                  ※団体名称の表記は変更できません。<br />
                  変更が必要な場合は、運営事務局までご連絡ください。
                </td>
              </tr>
              <!-- 団体名称(フリガナ） -->
              <tr>
                <td class="item-input-name">
                  団体名称(フリガナ）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name"></td>
                <td class="item-information">
                  <input
                    type="text"
                    pInputText
                    placeholder="例）ﾅｲｶｸﾌ"
                    class="information-Form-inputtext-wMax"
                    formControlName="organization_kana"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('organization_kana')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 法人番号 -->
              <tr>
                <td class="item-input-name">
                  法人番号(13裄)
                  <span class="required">【必須】</span>
                  <span class="warning-number">（半角数字）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  法人番号は<a
                    href="https://www.houjin-bangou.nta.go.jp/"
                    target="_blank"
                    >こちら</a
                  >からご確認できます。
                  <div class="w4">
                    <input
                      type="text"
                      pInputText
                      placeholder="例）1234567890123"
                      class="information-Form-inputtext-wMax"
                      formControlName="organization_no"
                    />
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('organization_no')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 郵便番号 -->
              <tr>
                <td class="item-input-name">
                  郵便番号
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input
                    type="text"
                    pInputText
                    placeholder="例）1008968"
                    class="information-Form-inputtext-wMax"
                    formControlName="postal_no"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('postal_no')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 都道府県 -->
              <tr>
                <td class="item-input-name">
                  都道府県
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input
                    type="text"
                    pInputText
                    placeholder="例）東京都"
                    class="information-Form-inputtext-wMax"
                    formControlName="prefectures"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('prefectures')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 所在地（市区町村） -->
              <tr>
                <td class="item-input-name">
                  所在地（市区町村）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input
                    type="text"
                    pInputText
                    placeholder="例）千代田区"
                    class="information-Form-inputtext-wMax"
                    formControlName="city"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b101InputForm.get('city')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 所在地（町域） -->
              <tr>
                <td class="item-input-name">
                  所在地（町域）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input
                    type="text"
                    pInputText
                    placeholder="例）永田町"
                    class="information-Form-inputtext-wMax"
                    formControlName="town_area"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('town_area')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 所在地（番地・建物 -->
              <tr>
                <td class="item-input-name">
                  所在地（番地・建物）
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input
                    type="text"
                    pInputText
                    placeholder="例）１－１１－３９　永田町合同庁舎８F"
                    class="information-Form-inputtext-wMax"
                    formControlName="address_building"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('address_building')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 業種 -->
              <tr>
                <td class="item-input-name">
                  業種
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown
                    [options]="industryIdCodeList"
                    optionLabel="sp_name"
                    optionValue="sp_code"
                    placeholder="選択してください"
                    [showClear]="true"
                    styleClass="information-Form-dropdown"
                    formControlName="industry_id"
                  ></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('industry_id')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 人口　-->
              <tr *ngIf="1 == classId || 9 == classId">
                <td class="item-input-name">
                  人口
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown
                    [options]="getDicList(4)"
                    optionLabel="sp_name"
                    optionValue="sp_code"
                    placeholder="選択してください"
                    [showClear]="true"
                    styleClass="information-Form-dropdown"
                    formControlName="population"
                  ></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('population')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 従業員数 -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">従業員数</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown
                    [options]="getDicList(5)"
                    optionLabel="sp_name"
                    optionValue="sp_code"
                    placeholder="選択してください"
                    [showClear]="true"
                    styleClass="information-Form-dropdown"
                    formControlName="employees_count"
                  ></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('employees_count')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 売上高 -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">売上高</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown
                    [options]="getDicList(6)"
                    optionLabel="sp_name"
                    optionValue="sp_code"
                    placeholder="選択してください"
                    [showClear]="true"
                    styleClass="information-Form-dropdown"
                    formControlName="sales_amount"
                  ></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('sales_amount')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 活動で貴団体が実現したいこと -->
              <tr>
                <td class="item-input-name">
                  本プラットフォームにおける<br />活動で実現したいこと
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    貴団体がSDGs達成に向けた活動により、何を目指すのか、何を実現したいのか
                    <label class="warning"> 200字以内 </label>
                    でご記載ください。<br />
                    （解決したい社会・地域課題、実現したい地域の姿などを具体的にお書きください。）
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-200"
                    formControlName="want"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b101InputForm.get('want')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 主要事業-->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">
                  主要事業
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    貴団体の主要事業を
                    <label class="warning"> 200字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-200"
                    formControlName="primary_business"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('primary_business')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- ウェブサイトURL  -->
              <tr>
                <td class="item-input-name">ウェブサイトURL</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  貴団体のホームページのURLを記載ください。
                  <input
                    type="text"
                    pInputText
                    placeholder="例）https://future-city.go.jp/"
                    class="information-Form-inputtext-wMax w12-inputtext"
                    formControlName="url"
                  />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="b101InputForm.get('url')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 重点的に取り組みたいテーマ -->
              <tr>
                <td class="item-input-name">
                  重点的に取り組みたいテーマ
                  <span class="required">【必須】</span><br />
                  （複数選択可）
                  <!-- ※最大３つまで選択可 -->
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information multi-line">
                  <div
                    class="two-line-content"
                    *ngFor="let category of categoryList"
                  >
                    <!-- カテゴリ大項目 -->
                    {{ category.class_name1 }}
                    <!-- カテゴリ中項目 -->
                    <div
                      class="category-checkbox"
                      *ngFor="let list of category.rec"
                    >
                      <p-checkbox
                        [label]="list.class_name2"
                        [value]="list.value"
                        [formControl]="
                          b101InputForm.controls['category_activities_forcus']
                        "
                      ></p-checkbox>
                    </div>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('category_activities_forcus')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 目指すSDGsゴール -->
              <tr>
                <td class="item-input-name">
                  目指すSDGsゴール<span class="required">【必須】</span><br />
                  （複数選択可）
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="p-d-flex button-area">
                    <button
                      pButton
                      type="button"
                      label="全て選択"
                      class="button1 check"
                      (click)="setCheckAll($event, true)"
                    ></button>
                    <button
                      pButton
                      type="button"
                      label="選択を外す"
                      class="button1"
                      (click)="setCheckAll($event, false)"
                    ></button>
                  </div>
                  <div class="multi-line">
                    <div
                      class="p-d-flex p-as-center checkbox-list two-line-content"
                      *ngFor="let dicData of getDicList(3)"
                    >
                      <p-checkbox
                        name="10"
                        [value]="dicData.sp_code"
                        [(ngModel)]="category_activities"
                        [formControl]="
                          b101InputForm.controls['category_activities']
                        "
                      >
                      </p-checkbox>
                      <div class="checkbox-img">
                        <img [src]="dicData.sp_ext" />
                      </div>
                      <div class="p-as-center">
                        {{ dicData.sp_code + "　" + dicData.sp_name }}
                      </div>
                    </div>
                  </div>

                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('category_activities')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 現在のSDGsに関する取組 -->
              <tr>
                <td class="item-input-name">現在のSDGsに関する取組</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    現在、SDGsの達成に向けた貴団体の具体的な取組状況について
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="activities_now"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('activities_now')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 今後取り組みたい内容 -->
              <tr>
                <td class="item-input-name">今後取り組みたい内容</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    SDGsの達成に向けて、今後取り組みたいことがあれば
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="activities_future"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('activities_future')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績１（案件タイトル） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績１（案件タイトル）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件のタイトルを、
                    <label class="warning"> 50字以内 </label>
                    でご記載ください。
                  </div>

                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-50"
                    formControlName="pap_ally1_title"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally1_title')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績１（概要） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績１（概要）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件の概要を、
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="pap_ally1_note"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally1_note')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績１（連携先） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績１（連携先）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件の連携先を、
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="pap_ally1_member_name"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally1_member_name')"
                  >
                  </app-validator-message>
                </td>
              </tr>

              <!-- 官民連携実績２（案件タイトル） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績２（案件タイトル）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件のタイトルを、
                    <label class="warning"> 50字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-50"
                    formControlName="pap_ally2_title"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally2_title')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績２（概要） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績２（概要）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件の概要を、
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="pap_ally2_note"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally2_note')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績２（連携先） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績２（連携先）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件の連携先を、
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="pap_ally2_member_name"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally2_member_name')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績３（案件タイトル） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績３（案件タイトル）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件のタイトルを、
                    <label class="warning"> 50字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-50"
                    formControlName="pap_ally3_title"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally3_title')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績３（概要） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績３（概要）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件の概要を、
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="pap_ally3_note"
                  ></textarea>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally3_note')"
                  >
                  </app-validator-message>
                </td>
              </tr>
              <!-- 官民連携実績３（連携先） -->
              <tr *ngIf="3 == classId || 9 == classId">
                <td class="item-input-name">官民連携実績３（連携先）</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div>
                    過去に官民連携の実績があれば、その代例となる案件の連携先を、
                    <label class="warning"> 400字以内 </label>
                    でご記載ください。
                  </div>
                  <textarea
                    pInputTextarea
                    class="information-Form-inputtext-wMax p-text-area-400"
                    formControlName="pap_ally3_member_name"
                  ></textarea>
                  <app-validator-message
                    [control]="b101InputForm.get('pap_ally3_member_name')"
                  >
                  </app-validator-message>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!b101InputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="b101InputForm.valid">
        <label class="warning platform-warning-text"> &nbsp; </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button
          pButton
          type="button"
          label="確認画面へ進む"
          class="button-default-size button1"
          (click)="moveB102()"
          [disabled]="!b101InputForm.valid"
        ></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- 自治体会員登録・更新画面(確認画面)(B102) -->
    <div class="input-form-information" *ngIf="confirmationFlag">
      <!-- タイトル -->
      <div class="title">
        <h1>会員プロフィール編集・内容確認</h1>
      </div>

      <!-- 備考 -->
      <div class="input-form-note">
        下記内容でよろしければ、「登録・更新する」ボタンを押してください。
      </div>

      <!-- 入力内容 -->
      <p-table [value]="[{}]" styleClass="information-Form">
        <ng-template pTemplate="body">
          <!-- 会員種別 -->
          <tr>
            <td class="item-input-name">会員種別</td>
            <td class="item-label-name"></td>
            <td class="item-information">
              <label *ngIf="9 != b101InputForm.value.class_id">
                {{ getDicName(1, b101InputForm.value.class_id) }}
              </label>
              <label *ngIf="9 == b101InputForm.value.class_id"> 事務局 </label>
            </td>
          </tr>

          <!-- 団体名称 -->
          <tr>
            <td class="item-input-name">団体名称</td>
            <td class="item-label-name"></td>
            <td class="item-information">
              <div>
                {{ b101InputForm.value.organization_name }}
                <br />
                ※団体名称の表記は変更できません。<br />
                　変更が必要な場合は、運営事務局までご連絡ください。
              </div>
            </td>
          </tr>

          <!-- 団体名称(フリガナ） -->
          <tr>
            <td class="item-input-name">団体名称(フリガナ）</td>
            <td class="item-label-name"></td>
            <td class="item-information">
              <div>
                {{ b101InputForm.value.organization_kana }}
              </div>
            </td>
          </tr>

          <!-- 法人番号(13裄) -->
          <tr>
            <td class="item-input-name">
              法人番号(13裄)
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.organization_no }}
            </td>
          </tr>

          <!-- 郵便番号 -->
          <tr>
            <td class="item-input-name">
              郵便番号
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.postal_no }}
            </td>
          </tr>

          <!-- 都道府県 -->
          <tr>
            <td class="item-input-name">
              都道府県
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              <div>{{ b101InputForm.value.prefectures }}</div>
            </td>
          </tr>

          <!-- 所在地（市区町村） -->
          <tr>
            <td class="item-input-name">
              所在地（市区町村）
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              <div>{{ b101InputForm.value.city }}</div>
            </td>
          </tr>

          <!-- 所在地（町域） -->
          <tr>
            <td class="item-input-name">
              所在地（町域）
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.town_area }}
            </td>
          </tr>

          <!-- 所在地（番地・建物） -->
          <tr>
            <td class="item-input-name">
              所在地（番地・建物）
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.address_building }}
            </td>
          </tr>

          <!-- 業種 -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">
              業種
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ getDicName(2, b101InputForm.value.industry_id) }}
            </td>
          </tr>

          <!-- 人口　-->
          <tr *ngIf="1 == classId || 9 == classId">
            <td class="item-input-name">
              人口 <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ getDicName(4, b101InputForm.value.population) }}
            </td>
          </tr>
          <!-- 従業員数　-->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">従業員数</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ getDicName(5, b101InputForm.value.employees_count) }}
            </td>
          </tr>
          <!-- 売上高-->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">
              売上高
              <span class="required"></span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ getDicName(6, b101InputForm.value.sales_amount) }}
            </td>
          </tr>

          <!-- 活動で貴団体が実現したいこと -->
          <tr>
            <td class="item-input-name">
              本プラットフォームにおける<br />活動で実現したいこと<br />
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.want }}
            </td>
          </tr>

          <!-- ウェブサイトURL -->
          <tr>
            <td class="item-input-name">ウェブサイトURL</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">{{ b101InputForm.value.url }}</td>
          </tr>

          <!-- 重点的に取り組みたいテーマ -->
          <tr>
            <td class="item-input-name">
              重点的に取り組みたいテーマ <br />
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              <div
                *ngFor="
                  let category of getClassNameList(
                    b101InputForm.value.category_activities_forcus
                  )
                "
              >
                {{ category.class_name2 }}
              </div>
            </td>
          </tr>
          <!-- 主要事業 -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">
              主要事業
              <span class="required">【必須】</span>
            </td>
            <td class="item-label-name"></td>
            <td class="item-information">
              {{ b101InputForm.value.primary_business }}
            </td>
          </tr>

          <!-- 目指すSDGsゴール -->
          <tr>
            <td class="item-input-name">
              目指すSDGsゴール<span class="required">【必須】</span>
            </td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              <div
                class="p-d-flex p-as-center checkbox-list"
                *ngFor="
                  let dicName of getDicNameList(
                    3,
                    b101InputForm.value.category_activities
                  )
                "
              >
                <div class="checkbox-img">
                  <img [src]="dicName.sp_ext" />
                </div>
                <div class="p-as-center">
                  {{ dicName.sp_code }}　{{ dicName.sp_name }}
                </div>
              </div>
            </td>
          </tr>
          <!-- 現在のSDGsに関する取組 -->
          <tr>
            <td class="item-input-name">現在のSDGsに関する取組</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.activities_now }}
            </td>
          </tr>
          <!-- 今後取り組みたい内容 -->
          <tr>
            <td class="item-input-name">今後取り組みたい内容</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.activities_future }}
            </td>
          </tr>
          <!-- 官民連携実績１（案件タイトル） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績１（案件タイトル）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally1_title }}
            </td>
          </tr>
          <!-- 官民連携実績１（概要） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績１（概要）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally1_note }}
            </td>
          </tr>
          <!-- 官民連携実績１（連携先 -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績１（連携先）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally1_member_name }}
            </td>
          </tr>
          <!--  官民連携実績２（案件タイトル） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績２（案件タイトル）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally2_title }}
            </td>
          </tr>
          <!-- 官民連携実績２（概要） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績２（概要）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally2_note }}
            </td>
          </tr>
          <!-- 官民連携実績２（連携先） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績２（連携先）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally2_member_name }}
            </td>
          </tr>
          <!-- 官民連携実績３（案件タイトル） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績３（案件タイトル）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally3_title }}
            </td>
          </tr>
          <!-- 官民連携実績３（概要） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績３（概要）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally3_note }}
            </td>
          </tr>
          <!-- 官民連携実績３（連携先） -->
          <tr *ngIf="3 == classId || 9 == classId">
            <td class="item-input-name">官民連携実績３（連携先）</td>
            <td class="item-label-name">
              <p-tag value="公開" styleClass="public-tag"></p-tag>
            </td>
            <td class="item-information">
              {{ b101InputForm.value.pap_ally3_member_name }}
            </td>
          </tr>
        </ng-template>
      </p-table>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area">
        <label class="warning platform-warning-text"> &nbsp; </label>
      </div>

      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button
          pButton
          type="button"
          label="登録・更新する"
          class="button-default-size button1"
          (click)="moveB103()"
        ></button>
        <button
          pButton
          type="button"
          label="修正する"
          class="button-default-size button2"
          (click)="moveB101()"
        ></button>
      </div>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
